import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../Button';
import Image from '../Image';

import './styles.less';

class CountdownClock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentDatetime: Date.now(),
            endDatetime: props.expireDatetime,
            duration: props.expireDatetime - Date.now(),
            expired: false
        };
    }

    componentDidMount() {
        this.timerID = setInterval(() => this.tick(), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
    }

    tick() {
        const now = Date.now();
        const duration = this.state.endDatetime - now;
        if (Math.round(duration) >= 0) {
            this.setState({
                currentexpireDatetime: now,
                duration
            });
        } else {
            clearInterval(this.timerID);
            this.setState(
                {
                    currentDatetime: now,
                    duration,
                    expired: true
                },
                this.props.onExpire
            );
        }
    }

    renderClock() {
        const breakdownTime = (duration) => {
            return {
                seconds: Math.round((duration / 1000) % 60),
                minutes: Math.round((duration / 60000) % 60),
                hours: Math.round((duration / 3600000) % 24),
                days: Math.round(duration / 86400000)
            };
        };
        const renderClockPanel = (readable, value) => {
            return (
                <div
                    className={classNames({
                        'p-countdown-clock__panel': true,
                        [`p-countdown-clock__panel--${this.props.size}`]: true
                    })}
                >
                    <div className="p-countdown-clock__label">{readable}</div>
                    <div className="p-countdown-clock__label--value">{value}</div>
                </div>
            );
        };
        const timeBreakdown = breakdownTime(this.state.duration);

        return (
            <div className={`p-countdown-clock p-countdown-clock--${this.props.size} p-countdown-clock--initialized`}>
                {this.props.image ? <Image {...this.props.image} className="p-countdown-clock__image" /> : null}
                <div className="p-countdown-clock__content">
                    {this.props.title ? (
                        <div className="p-countdown-clock__container p-countdown-clock__container--title">
                            <div
                                className={classNames({
                                    'u-text-h1': true,
                                    'p-countdown-clock__title': true,
                                    [`p-countdown-clock__title--${this.props.size}`]: true,
                                    'p-countdown-clock__title--dark': !this.props.image
                                })}
                            >
                                {this.props.title}
                            </div>
                        </div>
                    ) : null}
                    <div className="p-countdown-clock__container p-countdown-clock__container--time">
                        {this.props.showDays
                            ? renderClockPanel(this.props.i18n.unit_time_days, timeBreakdown.days)
                            : null}
                        {this.props.showHours
                            ? renderClockPanel(this.props.i18n.unit_time_hrs, timeBreakdown.hours)
                            : null}
                        {this.props.showMinutes
                            ? renderClockPanel(this.props.i18n.unit_time_mins, timeBreakdown.minutes)
                            : null}
                        {this.props.showSeconds
                            ? renderClockPanel(this.props.i18n.unit_time_secs, timeBreakdown.seconds)
                            : null}
                    </div>
                    {this.props.buttons ? (
                        <div className="p-countdown-clock__container p-countdown-clock__container--button">
                            {this.props.buttons.map((btn, i) => {
                                const key = i;
                                return (
                                    <div style={{ margin: '0 .5em 0 .5em' }} key={key}>
                                        <Button {...btn} />
                                    </div>
                                );
                            })}
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.props.removeAfterExpiration && this.state.expired ? null : this.renderClock()}
            </React.Fragment>
        );
    }
}

CountdownClock.propTypes = {
    size: PropTypes.oneOf(['sm', 'lg']),
    title: PropTypes.string,
    expireDatetime: PropTypes.number.isRequired,
    buttons: PropTypes.arrayOf(PropTypes.shape(Button.propTypes)),
    image: PropTypes.shape(Image.propTypes),
    showDays: PropTypes.bool,
    showHours: PropTypes.bool,
    showMinutes: PropTypes.bool,
    showSeconds: PropTypes.bool,
    removeAfterExpiration: PropTypes.bool,
    onExpire: PropTypes.func,
    i18n: PropTypes.shape({
        unit_time_days: PropTypes.string,
        unit_time_hrs: PropTypes.string,
        unit_time_mins: PropTypes.string,
        unit_time_secs: PropTypes.string
    })
};

CountdownClock.defaultProps = {
    size: 'sm',
    title: '',
    buttons: undefined,
    image: undefined,
    showDays: true,
    showHours: true,
    showMinutes: true,
    showSeconds: true,
    removeAfterExpiration: false,
    onExpire: () => {},
    i18n: {
        unit_time_days: 'Days',
        unit_time_hrs: 'Hrs',
        unit_time_mins: 'Mins',
        unit_time_secs: 'Secs'
    }
};

export default CountdownClock;
